import { render, staticRenderFns } from "./ServiceAlertContact.vue?vue&type=template&id=f70ee0dc&scoped=true&"
import script from "./ServiceAlertContact.vue?vue&type=script&lang=js&"
export * from "./ServiceAlertContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ee0dc",
  null
  
)

export default component.exports